export enum DotRezDomainCodes {
    Agency = "EXT",
    Members = "WWW",
}